import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin, Twitter, MapPin, Phone, Mail } from "lucide-react";
import { useSiteSettings } from "../lib/hooks";
import Logo from "./Logo";

const Footer = () => {
  const s = useSiteSettings();
  const socials = [
    { key: "instagram", Icon: Instagram },
    { key: "facebook", Icon: Facebook },
    { key: "youtube", Icon: Youtube },
    { key: "linkedin", Icon: Linkedin },
    { key: "twitter", Icon: Twitter },
  ].filter(({ key }) => s?.[key]);

  return (
    <footer className="bg-[#111111] text-white mt-24" data-testid="site-footer">
      <div className="container-wide py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Logo className="h-14 w-14" showWordmark invert />
            <p className="mt-6 text-white/70 text-sm leading-relaxed max-w-sm">
              Multi-brand pre-owned car showroom. Carefully selected vehicles, transparent buying, refined experience.
            </p>
            <p className="mt-4 text-[10px] tracking-[0.3em] text-[#7A1519] font-semibold uppercase">
              Adding Luxury to Life
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-white/50 mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/cars" className="text-white/80 hover-champagne">Buy a Car</Link></li>
              <li><Link to="/latest-arrivals" className="text-white/80 hover-champagne">Latest Arrivals</Link></li>
              <li><Link to="/sell-your-car" className="text-white/80 hover-champagne">Sell Your Car</Link></li>
              <li><Link to="/emi-calculator" className="text-white/80 hover-champagne">EMI Calculator</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-white/50 mb-4">About</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/80 hover-champagne">Our Story</Link></li>
              <li><Link to="/reviews" className="text-white/80 hover-champagne">Reviews</Link></li>
              <li><Link to="/contact" className="text-white/80 hover-champagne">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-white/50 mb-4">Showroom</div>
            <div className="space-y-3 text-sm text-white/80">
              <div className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#7A1519]" /><span>{s?.address || "—"}</span></div>
              <div className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-[#7A1519]" /><a href={`tel:${s?.phone}`} className="hover-champagne">{s?.phone || "—"}</a></div>
              <div className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-[#7A1519]" /><a href={`mailto:${s?.email}`} className="hover-champagne">{s?.email || "—"}</a></div>
              <div className="text-white/60">{s?.opening_hours}</div>
            </div>
            {socials.length > 0 && (
              <div className="flex gap-4 mt-6" data-testid="footer-socials">
                {socials.map(({ key, Icon }) => (
                  <a key={key} href={s[key]} target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#7A1519] transition-colors" aria-label={key}>
                    <Icon size={18} />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Autobahn Cars &amp; Wheels. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/admin" className="hover-champagne/80" target="_blank" rel="noreferrer" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
